// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.consultBtnHandler(); // 咨询弹窗
  },
  consultBtnHandler() {
    // 咨询弹窗
    $('.consult-btn').on('click', ()=> {
      $('.consult-modal').addClass('consult-modal-active');
      // 禁用页面滚动
      $('body').addClass('scroll-lock');
    });

    // 关闭咨询弹窗
    $('.consult-modal-close').on('click', ()=> {
      $('.consult-modal').removeClass('consult-modal-active');
      // 恢复页面滚动
      $('body').removeClass('scroll-lock');
    });
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
